import { type CreateControllerFn } from '@wix/yoshi-flow-editor';

import { LOGIN_MENU_ID } from '../../constants';
import type { FlowAPI } from '../../types';
import {
  isProfilePageBoBInstalled,
  isSettingsPageInstalled,
} from '../../utils/site';
import { initBuyAgain } from '../members-login-bar/shared/buy-again';
import { controllerCurrentMA } from './current-ma';
import { controllerMAV2 } from './ma-v2';
import { controllerMAV3 } from './ma-v3';

const getGlobalController = async (flowAPI: FlowAPI) => {
  const [shouldUseV3Context, shouldUseV2Context] = await Promise.all([
    isSettingsPageInstalled(flowAPI.controllerConfig.wixCodeApi),
    isProfilePageBoBInstalled(flowAPI.controllerConfig.wixCodeApi),
  ]);

  if (shouldUseV3Context) {
    return controllerMAV3;
  }

  if (shouldUseV2Context) {
    return controllerMAV2;
  }

  return controllerCurrentMA;
};

const createController: CreateControllerFn = async (props) => {
  const globalController = await getGlobalController(props.flowAPI);
  const controller = await globalController(props);
  const pageReady = controller.pageReady;

  controller.pageReady = async function (...args) {
    await pageReady.apply(this, args);

    const { $w, wixCodeApi, appParams } = props.controllerConfig;
    // Older login bars connect directly to the global Members controller.
    for (const loginBar of $w(LOGIN_MENU_ID)) {
      await initBuyAgain(
        { $w, wixCodeApi, appParams, flowAPI: props.flowAPI },
        loginBar,
      );
    }
  };

  return controller;
};

export default createController;
